import { AmendSidePanel } from 'components/Workspaces/SecondaryMarketPostEvent/Tabs/shared/AmendSidePanel';
import { connectAmendSidePanelFactory } from 'components/Workspaces/SecondaryMarketPostEvent/Tabs/shared/sidePanel.connect';
import { connect } from 'react-redux';
import { liveAmendSelectors } from 'state/secondaryMarket/live/amend/amend.selectors';
import { liveInputFormActions } from 'state/secondaryMarket/live/form/input/inputForm.actions';
import { liveKycSelectors } from 'state/secondaryMarket/live/kyc/kyc.selectors';
import { liveSelectors } from 'state/secondaryMarket/live/live.selector';
import { liveThunks } from 'state/secondaryMarket/live/live.thunk';

export const { mapStateToProps, mapDispatchToProps } = connectAmendSidePanelFactory(
  liveSelectors,
  liveKycSelectors,
  liveAmendSelectors,
  liveThunks,
  liveInputFormActions,
);

export const connectAmendLiveTradeSidePanel = connect(mapStateToProps, mapDispatchToProps);

export const ConnectedAmendLiveTradeSidePanel = connectAmendLiveTradeSidePanel(AmendSidePanel);
